// extracted by mini-css-extract-plugin
export default {"mobile-nav":"MobileNav_mobile-nav__1G4LP","open":"MobileNav_open__mpwbD"};